import React, { useRef } from "react"
import PropTypes from "prop-types"

import { BodyCopy } from "./BodyCopy"
import { Carousel } from "./Carousel"
import { ArtistQuote } from "./ArtistQuote"
import { VideoGallery } from "./VideoGallery"

const contentComponentTypes = {
  carousel: "ContentfulComponentImageCarousel",
  artistQuote: "ContentfulComponentQuote",
  bodyCopy: "ContentfulComponentBodyCopy",
  videoGallery: "ContentfulComponentVideoGallery",
}

export function ContentComponents({ components }) {
  const bodyCopyRef = useRef(null)

  return components.map((component, i) => {
    const key = `${component.__typename}_${i}`

    switch (component.__typename) {
      case contentComponentTypes.bodyCopy:
        const body = component.body.childMarkdownRemark.html

        return <BodyCopy body={body} key={key} wrapperRef={bodyCopyRef} />

      case contentComponentTypes.carousel:
        const images = (component.images || []).map(image => ({
          caption: image.description,
          url: image.file.url,
          fluid: image.fluid,
        }))

        return <Carousel images={images} key={key} bodyCopyRef={bodyCopyRef} />

      case contentComponentTypes.artistQuote:
        const quote = component.captionCopy.captionCopy
        const author = component.author

        return <ArtistQuote quote={quote} author={author} key={key} />

      case contentComponentTypes.videoGallery:
        const { videos } = component

        return (
          <VideoGallery
            videos={videos.map(video => ({
              title: video.title,
              subtitle: video.subtitle,
              url: video.videoUrl,
            }))}
            key={key}
          />
        )

      default:
        console.error(`Unrecognized content component: ${component.__typename}`)

        return null
    }
  })
}

ContentComponents.propTypes = {
  components: PropTypes.arrayOf(
    PropTypes.shape({ __typename: PropTypes.string.isRequired })
  ),
}
